import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import ChaseLogicProvider from "./providers/chase-logic-provider";
import EnterChaseNumber from "./components/enter-chase-number";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <MainLayout>
            <EnterChaseNumber />
          </MainLayout>
        } />
        <Route path="/:id" element={<ChaseLogicProvider>
          <MainLayout />
        </ChaseLogicProvider>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
